class QbWebhooksCtrl {
  constructor(SchemaService, FEService, TBService, EventService, TemplateService, $scope, $filter, AuthService, $window) {
    'ngInject';
    this.fe = FEService;
    this.tb = TBService;
    this.ts = TemplateService;
    this.es = EventService;
    this.ss = SchemaService;
    this.as = AuthService;
    this.$scope = $scope;
    this.$filter = $filter;
    this.$window = $window;
    this.provider = 'Data Provider';
    this.newHook = {};
    this.template = {};
    this.messages = [];
    this.references = [];
    this.tokens = [];
    this.createdHookUrl = '';
    this.createdHookName = '';
    this.modalDescription = '';
    this.loading = false;
  }

  cancel() {
    this.onCancel();
  }

  async $onInit() {
    try {
      this.provider = await this.as.provider();

      const waitBindings = ["hookType"];
      [this.td ] = await Promise.all([
        this.ts.getTemplateData(),
        this.fe.waitForBindings(waitBindings, this.$scope)
      ]);
      
      const { hookType } = this;
      this.requireSuppliedConn = !this.td.template.connectionProperties.includes("usertoken");
      this.signTemplate = this.td.template.signTemplate === true;

      this.initWebhook(hookType);
      
    } catch (error) {
      this.handleMessage({error, when: "During Page Setup"});
    }

  }
  
  initWebhook(hookType){
    this.newHook.hookType = hookType;
    
    switch (hookType) {
      case 'genFromId':
        this.newHook.label = `Generate ${this.td.template.title} PDF`;
        this.modalDescription = 'PDF Generation';
        break;
      case 'importFromPdf':
        this.newHook.label = `Parse Submitted Document - ${this.td.template.title}`;
        this.newHook.urlField = '';
        this.modalDescription = 'PDF-Import';
        break;
      default:
        break;
    }
  }

  async add(newHook) {
    const msg = `Adding a webhook will prevent the addition and removal of Target Tables. \nContinue?`;
    
    if (!this.td.template.published && !this.$window.confirm(msg)) {
      return; 
    }
    
    try {
      this.loading = true;
      this.messages = []; //clear previous errors/warnings
      newHook.ridField = this.sourceSchema?.fields.find(f => f.id == 3);
      const res = await this.tb.addTemplateHook(this.ts.toRaw({includeRefs: true}), newHook);
      
      const { "data": { messages, "newHook": { label, publicUrl } } } = res;

      messages.forEach( msg => this.handleMessage(msg));
      //TODO errorMessages
      this.createdHookName = label;
      this.createdHookUrl = publicUrl;
      this.addWebhookNote();

    } catch (error) {
      this.handleMessage({error, when: "When Creating the new Webhook"});
    }
    
    this.loading = false;
  }
  
  addWebhookNote() {
    const message = 'Webhooks can create and modify records! \nTake care to ensure the action performed by the webhook does not trigger the webhook again, creating an infinite loop.';
    this.handleMessage({message, alertClass: 'info'});
  }
  
  filterFileFields() { //includig text too...
    return (field) => field.fieldType === 'file';
  }
  
  handleMessage(rawMessage) {
    this.messages = this.fe.updateMessages(this.messages, rawMessage);
    if (rawMessage.error) console.error(rawMessage.error);
  }

  
}

export default {
  bindings: {
    hookType: "<",
    onCancel: "&"
  },
  templateUrl: "providers/quick-base/qb-webhooks/qb-webhooks.component.html",
  controller: QbWebhooksCtrl
};
